module.exports = __webpack_public_path__ + "img/success_icon.fc68ee98.png";